import React from 'react'
import PropTypes from 'prop-types'
import { Avatar as MuiAvatar, useTheme } from '@mui/material'

const spacing = {
    small: 3,
    medium: 4,
    large: 5,
}

const Avatar = ({ size, src, alt = '', ...rest }) => {
    const theme = useTheme()

    // Extract name from rest props if provided
    const { name, ...otherRest } = rest

    // Determine the best alt text:
    // 1. If alt is explicitly provided and not empty, use it
    // 2. If name is provided, use it as the alt text
    // 3. Otherwise, use empty string (decorative)
    const altText = alt !== '' ? alt : name ? name : ''

    return (
        <MuiAvatar
            sx={{
                position: 'relative',
                isolation: 'isolate',
                width: theme.spacing(spacing[size]),
                height: theme.spacing(spacing[size]),
                overflow: 'visible',
                borderRadius: '100vw',
                boxShadow: 'none !important',
                '& > img, & > svg': {
                    position: 'relative',
                    zIndex: 0,
                    borderRadius: '100vw',
                    boxShadow: 'none !important',
                },
                '&:not(:empty)::after': {
                    content: '""',
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    zIndex: '-1',
                    inset: 0,
                    transform: 'translate(2.5%, 6%)',
                    borderRadius: '100vw',
                    boxShadow: 'none !important',
                    pointerEvents: 'none',
                    filter: 'blur(5px)',
                    background: theme.palette.grey[400],
                    backgroundImage: `url(${src})`,
                    backgroundSize: 'cover',
                },
            }}
            src={src}
            alt={altText}
            {...otherRest}
        />
    )
}

Avatar.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    src: PropTypes.string,
    alt: PropTypes.string,
    // name is handled through ...rest props
}

Avatar.defaultProps = {
    size: 'small',
}

export default Avatar
